import React, { Component } from "react";

class EmptyLayout extends Component {
  render() {
    return <>{this.props.children}</>;
  }
}

export default EmptyLayout;
